import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
export const ComparisonWidget = () => {
  const [isVisible, setIsVisible] = useState(true);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 right-4 z-40 bg-white rounded-lg shadow-xl p-4 w-64 border border-indigo-100 animate-fadeIn" data-id="element-109">
      <div className="flex justify-between items-center mb-3" data-id="element-110">
        <h3 className="font-bold text-indigo-900 text-sm" data-id="element-111">
          Pills vs. Sleep Restore - Quick Compare
        </h3>
        <button onClick={() => setIsVisible(false)} className="text-gray-500 hover:text-gray-700" aria-label="Close comparison widget" data-id="element-112">
          <XIcon className="h-4 w-4" data-id="element-113" />
        </button>
      </div>
      <div className="flex flex-col space-y-2 text-sm" data-id="element-114">
        <div className="flex" data-id="element-115">
          <div className="w-1/2 bg-red-50 p-2 rounded-l-md" data-id="element-116">
            <span className="font-medium text-red-700" data-id="element-117">Sleeping Pills:</span>
            <ul className="mt-1 text-gray-700 list-disc pl-4 text-xs" data-id="element-118">
              <li data-id="element-119">Sedation</li>
              <li data-id="element-120">Dependency</li>
              <li data-id="element-121">Grogginess</li>
            </ul>
          </div>
          <div className="w-1/2 bg-indigo-50 p-2 rounded-r-md" data-id="element-122">
            <span className="font-medium text-indigo-700" data-id="element-123">Sleep Restore:</span>
            <ul className="mt-1 text-gray-700 list-disc pl-4 text-xs" data-id="element-124">
              <li data-id="element-125">Natural</li>
              <li data-id="element-126">Mint Strips</li>
              <li data-id="element-127">Refreshing</li>
            </ul>
          </div>
        </div>
      </div>
      <a href="#buy-now" className="mt-3 bg-indigo-600 hover:bg-indigo-700 text-white text-sm py-2 px-4 rounded-full font-medium block text-center transition-colors" data-id="element-128">
        Try Sleep Restore
      </a>
    </div>;
};